import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
  SimpleChanges,
  ViewChild,
} from '@angular/core';
import {
  PCTableInputModel,
  PCTableOutputModel,
} from '../../models/pc-table-input-model';
import { TabelPaging } from '../../interfaces/table';
import { LoggerService } from 'src/app/services/logger.service';
import { Field } from '../../models/entity-defin';
import { PCTableComponent } from '../pctable/pctable.component';

@Component({
  selector: 'app-search-box',
  templateUrl: './search-box.component.html',
  styleUrls: ['./search-box.component.css'],
})
export class SearchBoxComponent implements OnChanges {
  constructor(private logger: LoggerService) {}

  @Input() data?: PCTableInputModel;
  @Input() right?: string;
  @Input() leftTriangle?: string;
  @Input() fields?: Field[];
  @Input() addButton?: boolean;
  @Input() urlName?: string;
  @Input() paging?: TabelPaging;
  @Input() modalIsOpen?: boolean;
  @Input() initOnChange?: boolean;
  @Output() parentAction = new EventEmitter<PCTableOutputModel>();
  @ViewChild(PCTableComponent) pcTableComponent!: PCTableComponent;

  // public width: number = 0;
  // public height: number = 0;
  // public top: number = 0;
  // public left: number = 0;
  // public leftTriangle: number = 0;

  public InitPage() {
    if (this.fields == null || this.fields.length == 0) {
      this.logger.addError('fields Empty', false);
      return;
    }
    this.right = this.right ?? '-10%';
    this.pcTableComponent.InitPage();
  }

  public RebuildColumn() {
    this.pcTableComponent.RebuildColumn();
  }

  public insideTableAction(event) {
    this.data = undefined;
    this.parentAction.next(event);
  }

  public addEvent() {
    const parentItem = new PCTableOutputModel('AddItem', undefined);

    this.insideTableAction(parentItem);
  }

  public ngOnChanges(changes: SimpleChanges) {
    if (
      changes &&
      changes['data'] &&
      changes['data'].currentValue !== undefined
    ) {
      const newData = changes['data'].currentValue;

      if (newData && newData.data) {
        if (this.fields == null || this.fields.length == 0) {
          this.logger.addError('fields Empty', false);
          return;
        }
        this.InitPage();
        // this.top = 0;
        // this.width = 0;
        // this.height = 0;

        const tableElement = document.querySelectorAll(
          '.table-responsive,.search-box'
        );
        if (tableElement && tableElement.length != 0) {
          const thisItem = tableElement[0];
          // if (thisItem.clientHeight < this.height) {
          //   this.height = thisItem.clientHeight * 1.2;
          // }
        }
      }
    }

    if (this.addButton == null) {
      this.addButton = false;
    }
    // if (this.top == 0) {
    //   const parentElement = document.getElementsByClassName('search-input-box');

    //   if (parentElement && parentElement.length != 0) {
    //     const thisItem: any = parentElement[0];
    //     this.top = thisItem.offsetTop + thisItem.clientHeight + 14;
    //   }
    // }
    // if (this.width == 0) {
    //   const parentElement = document.getElementsByClassName('app-root');
    //   const drugNameId = document.getElementById('drugBrandName');
    //   if (
    //     parentElement &&
    //     parentElement.length != 0 &&
    //     drugNameId != undefined
    //   ) {
    //     const thisItem = parentElement[0];
    //     // this.width = thisItem.clientWidth * 0.8;
    //     this.width = thisItem.clientWidth;
    //     var elemRect = drugNameId.getBoundingClientRect();
    //     this.left =0;
    //     this.leftTriangle = elemRect.left + elemRect.width / 2;
    //   }
    // }

    // if (this.height == 0) {
    //   const parentElement = document.getElementsByClassName('app-root');
    //   if (parentElement && parentElement.length != 0) {
    //     const thisItem = parentElement[0];
    //     this.height = thisItem.clientHeight - this.top;
    //   }
    // }
  }
}
